import { RateCardType } from '@types';

export const getRateCardTypeLabel = (value: RateCardType) => {
	switch (value) {
	case 'PALLETS':
		return 'Pallets';
	case 'WEIGHT':
		return 'Tonnes';
	case 'CPK':
		return 'CPK';
	case 'FULL_LOAD':
		return 'Full Load';
	case 'ITEM':
		return 'Less Than';
	default:
		break;
	}
}
